import { Map } from "immutable";
import JwtDecode from "jwt-decode";

export const getDefaultValue = {
  maxPriority: 9999,
};

export const getUniqueId = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
export const numberWithCommas = (x) => {
  if (!x) return 0;
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
export const numberWithoutCommas = (x) => {
  return x.toString().replace(",", "");
};

export const stringToArray = (str, spliter = ",") => {
  if (!str || str == "") return [];
  let rawarr = str.split(spliter);
  let arr = [];
  rawarr.map((r) => r && arr.push(r));
  return arr;
};

export const arrayToString = (array, spliter = ",") => {
  let str = null;

  array.forEach((element) => {
    if (str) str += "," + element;
    else str = element;
  });
  return str;
};

export const arrayValueToString = (array) => {
  return array.map((element) => element.toString());
};

export function clearToken() {
  localStorage.removeItem("id_token");
}

export function getToken() {
  try {
    const idToken = localStorage.getItem("id_token");
    return new Map({ idToken });
  } catch (err) {
    clearToken();
    return new Map();
  }
}

export function getUserRole() {
  try {
    /*
      var jwtDecode = require("jwt-decode");
      const token = localStorage.getItem("id_token");
      let role = null;
      if (token) {
        const decoded = jwtDecode(token);
        if (decoded) role = decoded.Role;
  
        if (!role || role == "")
          role =
            decoded[
              "role"
            ];
        if (role) role = role.toLowerCase();
  
        return { role, shopId };
          }
        */
    return { role: "admin" }
  } catch (err) {
    return null;
  }
}

export function clearConfig() {
  localStorage.removeItem("config");
}
export function setConfig(config) {
  localStorage.setItem("config", JSON.stringify(config));
}
export function getConfig() {
  try {
    const config = localStorage.getItem("config");
    return JSON.parse(config);
  } catch (err) {
    clearConfig();
    return {};
  }
}

export function timeDifference(givenTime) {
  givenTime = new Date(givenTime);
  const milliseconds = new Date().getTime() - givenTime.getTime();
  const numberEnding = (number) => {
    return number > 1 ? "s" : "";
  };
  const number = (num) => (num > 9 ? "" + num : "0" + num);
  const getTime = () => {
    let temp = Math.floor(milliseconds / 1000);
    const years = Math.floor(temp / 31536000);
    if (years) {
      const month = number(givenTime.getUTCMonth() + 1);
      const day = number(givenTime.getUTCDate());
      const year = givenTime.getUTCFullYear() % 100;
      return `${day}-${month}-${year}`;
    }
    const days = Math.floor((temp %= 31536000) / 86400);
    if (days) {
      if (days < 28) {
        return days + " day" + numberEnding(days);
      } else {
        const months = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        const month = months[givenTime.getUTCMonth()];
        const day = number(givenTime.getUTCDate());
        return `${day} ${month}`;
      }
    }
    const hours = Math.floor((temp %= 86400) / 3600);
    if (hours) {
      return `${hours} hour${numberEnding(hours)} ago`;
    }
    const minutes = Math.floor((temp %= 3600) / 60);
    if (minutes) {
      return `${minutes} minute${numberEnding(minutes)} ago`;
    }
    return "a few seconds ago";
  };
  return getTime();
}

export function stringToInt(value, defValue = 0) {
  if (!value) {
    return 0;
  } else if (!isNaN(value)) {
    return parseInt(value, 10);
  }
  return defValue;
}

export function stringToPosetiveInt(value, defValue = 0) {
  const val = stringToInt(value, defValue);
  return val > -1 ? val : defValue;
}


export const getMaxPriority = (array) => {
  let maxPriority;
  array.forEach((element) => {
    if (!maxPriority || element.priority > maxPriority)
      maxPriority = element.priority;
  });
  return maxPriority || 0;
};

export const getMinPriority = (array) => {
  let minPriority;
  array.forEach((element) => {
    if (!minPriority || element.priority < minPriority)
      minPriority = element.priority;
  });
  return minPriority || 0;
};
